/* eslint-disable react/jsx-handler-names */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import styles from '../styles.styl';
import Button from '../../../../Button';
import { loggedUserIdSelector } from '../../../../../redux/context/selectors';
import ProgressBar from '../../../../VirtualVideoTest/Components/Progress/ProgressBar';
import { getConnectionResult } from '../../../../VirtualVideoTest/utils/getTestResults';
import { useTestConnection } from '../../../../../redux/opentok/hooks/useTestConnection';

function TestButtonPortal({ children }) {
  const wrapper = document.getElementById('media-settings-button');
  if (!wrapper) return null;
  return createPortal(children, wrapper);
}

function TestConnection({ formatMessage }) {
  const userId = useSelector(loggedUserIdSelector);

  const {
    disabled,
    buttonProps,
    stopTesting,
    progress,
    finished,
    testOpened,
    result,
  } = useTestConnection({ userId });

  useEffect(() => () => stopTesting(), []);

  const testResult = getConnectionResult(result);
  const danger = finished && testResult.danger;

  const title = `${formatMessage({
    id: 'virtualVisit.test.completed',
  })}: ${formatMessage({ id: testResult.qualityId })} ${formatMessage({
    id: 'virtualVisit.test.connectivity',
  })}`;

  return (
    <React.Fragment>
      {testOpened && (
        <div className="mb3">
          <h5
            className={cn(styles.title, {
              [styles.titleDanger]: danger,
            })}
          >
            {!finished
              ? formatMessage({ id: 'virtualVisit.test.progress' })
              : title}
          </h5>
          {!finished && (
            <ProgressBar
              progress={progress}
              height={8}
              transitionDuration="1s"
            />
          )}
        </div>
      )}

      <TestButtonPortal>
        <Button
          raised
          type="button"
          disabled={disabled}
          color={buttonProps.color}
          onClick={buttonProps.onClick}
        >
          {formatMessage({ id: buttonProps.title })}
        </Button>
      </TestButtonPortal>
    </React.Fragment>
  );
}

TestConnection.propTypes = {
  formatMessage: PropTypes.func,
};

export default TestConnection;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/MediaSettings/TestConnection/index.jsx